/**
 * `auth:unauthorized` 这一个事件,两条来路。
 *
 * 它本来只由 401 拦截器派发(会话已经没了),监听者据此做两类事:
 *   A. 清掉自己模块级的私有缓存 / 停掉长连接 —— view lookup、task subtype、Reactivate
 *      记忆、badge & call WebSocket;
 *   B. 走登出 + 跳登录页 —— AuthContext 的 401 处理、hooks/useAuth。
 *
 * **用户主动退出**需要的恰好是 A:模块级缓存活得比登录会话长(统一退出不 reload 页面),
 * 不清的话同一个 tab 里下一个登入的用户会继承上一个用户的私有数据。为此原来有一个
 * `utils/sessionCaches.ts` 集中登记点,把三个业务模块静态 import 进 app shell(每加一个
 * 缓存就要记得改两处:自己的监听 + 那张表)。改为让统一退出派发同一个事件、带上
 * `reason: 'sign_out'`,复用各模块已有的监听器;B 类监听者按 reason 跳过 —— 否则会再登出
 * 一次(重入)并把用户硬跳到登录页,而那是主动退出流程自己该决定的事。
 */
export const SIGN_OUT_REASON = 'sign_out'

/** 这个 `auth:unauthorized` 是「用户主动退出」发的,不是 401。 */
export function isDeliberateSignOut(event: Event): boolean {
  const detail = (event as CustomEvent).detail as { reason?: unknown } | null | undefined
  return detail?.reason === SIGN_OUT_REASON
}

/** 统一退出:广播给所有清缓存 / 断连接的监听者(见上)。 */
export function announceSignOut(): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent('auth:unauthorized', { detail: { reason: SIGN_OUT_REASON } }))
}
